import { render, staticRenderFns } from "./MockAuthorisation.vue?vue&type=template&id=4ca3f6f3&"
import script from "./MockAuthorisation.vue?vue&type=script&lang=js&"
export * from "./MockAuthorisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports